import DrawerButton from '../Button/DrawerButton';

type Props = {
  supTitle: string;
  title: string;
  subTitle?: string;
  children?: React.ReactNode;
};

export default function CallToAction({
  supTitle,
  title,
  subTitle,
  children,
}: Props) {
  return (
    <div className="bg-white sm:max-w-md sm:w-full rounded-[3rem] sm:overflow-hidden">
      <div className="px-4 py-8 sm:px-10">
        <p className="text-sm font-medium text-gray-700 uppercase">
          {supTitle}
        </p>

        <h1 className="mt-4 mb-8 text-2xl font-bold leading-7 text-gray-900 sm:text-4xl">
          {title}
        </h1>
        {subTitle && <p className="mb-8">{subTitle}</p>}
        {children || <DrawerButton size="lg">Get a Free Quote</DrawerButton>}
      </div>
    </div>
  );
}
